import { useState } from "react";
import "./LoginPage.css";

export default function AuthPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleAuth = async (endpoint: string) => {
    const res = await fetch(`/apiopen/${endpoint}`, {
      method: "POST",
      credentials: "include", // for cookies
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: username, password: password }),
    });

    if (res.ok) {
      window.location.href = "/";
    } else {
      alert("Auth failed");
    }
  };

  return (
    <div className="auth-container">
      <form className="auth-box" onSubmit={(e) => e.preventDefault()}>
        <h2>Welcome to Rate It</h2>
        <input
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <div className="button-group">
          <button onClick={() => handleAuth("login")}>Login</button>
          <button onClick={() => handleAuth("register")}>Register</button>
        </div>
      </form>
    </div>
  );
}
